import { c as _c } from "react/compiler-runtime";
import { Position } from '@xyflow/react';
import { useCallback } from 'react';
import type { BaseNodeData } from '../_schemas/node';

/**
 * Hook to compute layout positions and visual state for graph nodes.
 * Extracts common logic shared across LetterNode, TraitNode, and ArticulationNode.
 */
export function useNodeLayout(nodeData, handleColorClass, selected) {
  const $ = _c(9);
  const isRadial = nodeData.layoutMode === "radial";
  const isHierarchical = nodeData.layoutMode === "hierarchical";
  const isVertical = nodeData.hierarchyDirection === "vertical";
  const isVerticalLayout = isRadial || isHierarchical && isVertical;
  const targetPosition = isVerticalLayout ? Position.Top : Position.Left;
  const sourcePosition = isVerticalLayout ? Position.Bottom : Position.Right;
  let t0;
  if ($[0] !== handleColorClass || $[1] !== nodeData.isFloating) {
    t0 = hasEdge => {
      if (nodeData.isFloating || !hasEdge) {
        return "hidden";
      }
      return `size-2 border-0! ${handleColorClass}`;
    };
    $[0] = handleColorClass;
    $[1] = nodeData.isFloating;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getHandleClass = t0;
  const isActive = selected || nodeData.isHighlighted;
  const isDimmed = nodeData.isDimmed && !isActive;
  let t1;
  if ($[3] !== getHandleClass || $[4] !== isActive || $[5] !== isDimmed || $[6] !== sourcePosition || $[7] !== targetPosition) {
    t1 = {
      targetPosition,
      sourcePosition,
      getHandleClass,
      isActive,
      isDimmed
    };
    $[3] = getHandleClass;
    $[4] = isActive;
    $[5] = isDimmed;
    $[6] = sourcePosition;
    $[7] = targetPosition;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}